import React, { useState } from "react";
import { Table, Placeholder } from "react-bootstrap"; // <-- 1. Import Placeholder

interface Column {
    key: string;
    label: string;
}

interface ReservationsTableProps {
    columns: Column[];
    data: { [key: string]: any }[];
    isFetching?: boolean; // <-- 2. Tambahkan isFetching sebagai prop opsional
}

const ReservationsTable: React.FC<ReservationsTableProps> = ({ columns, data, isFetching }) => {
    const [search, _setSearch] = useState("");

    const filteredData = data.filter((row) =>
        columns.some((col) =>
            row[col.key]?.toString().toLowerCase().includes(search.toLowerCase())
        )
    );

    return (
        <div className="table-responsive mt-4">
            <Table striped bordered hover>
                <thead>
                    <tr>
                        {columns.map((col, index) => (
                            <th key={index}>{col.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {/* 3. Tambahkan logika untuk menampilkan skeleton, data, atau pesan "No data" */}
                    {isFetching ? (
                        // Tampilkan 5 baris skeleton saat loading
                        Array.from({ length: 5 }).map((_, rowIndex) => (
                            <tr key={`skeleton-${rowIndex}`}>
                                {columns.map((_, colIndex) => (
                                    <td key={`skeleton-cell-${colIndex}`}>
                                        <Placeholder animation="glow">
                                            <Placeholder xs={12} />
                                        </Placeholder>
                                    </td>
                                ))}
                            </tr>
                        ))
                    ) : filteredData && filteredData.length > 0 ? (
                        // Tampilkan data jika sudah selesai loading dan ada isinya
                        filteredData.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {columns.map((col, colIndex) => (
                                    <td key={colIndex}>{row[col.key]}</td>
                                ))}
                            </tr>
                        ))
                    ) : (
                        // Tampilkan pesan "No data" jika tidak loading dan tidak ada data
                        <tr>
                            <td colSpan={columns.length} className="text-center">
                                No data available
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default ReservationsTable;